var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","z-index":"1"}},[_c('div',{staticClass:"box-emprty"},[_c('div',{staticClass:"emptyBox"},[_c('img',{staticClass:"emimg",attrs:{"src":_vm.emptyImg}}),_c('span',{staticClass:"tip-text"},[_vm._v("当前科室暂无预约数据！")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }